import { BackIcon } from "~/icons/BackIcon";
import styles from "./IconButton.module.scss";
import React from "react";

export default function IconButtonBack({ onClick }) {
    return (
        <div onClick={onClick} className={styles["icon-button"]}>
            <BackIcon />
        </div>
    );
}
